export default __webpack_public_path__ + "static/media/LostRfpActive.1696f47d.svg";